module.exports = __webpack_public_path__ + "static/img/sm7.38d6196.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sm7.png
// module id = IvZl
// module chunks = 1